<template>
  <div>
    <gmap-map
      :center="center"
      :zoom="12"
	  :options="mapStyles"
      style="width:100%;  height: 340px;"
    >
	<gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center=m.position"
		:icon="mapIcon"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
    name: "GoogleMap",
	props: ['lat', 'lng'],
	data() {
		return {
		  center: {},
		  markers: [],
		  places: [],
		  currentPlace: null,
		  mapStyles: {
			  styles: [
				    {
				        "featureType": "all",
				        "elementType": "geometry.fill",
				        "stylers": [
				            {
				                "color": "#ffffff"
				            }
				        ]
				    },
				    {
				        "featureType": "landscape.natural",
				        "elementType": "geometry.fill",
				        "stylers": [
				            {
				                "visibility": "on"
				            },
				            {
				                "color": "#e0efef"
				            }
				        ]
				    },
				    {
				        "featureType": "poi",
				        "elementType": "geometry.fill",
				        "stylers": [
				            {
				                "visibility": "on"
				            },
				            {
				                "color": "#3cdbc0"
				            },
				            {
				                "gamma": "1.52"
				            },
				            {
				                "lightness": "12"
				            },
				            {
				                "saturation": "-10"
				            }
				        ]
				    },
				    {
				        "featureType": "road",
				        "elementType": "geometry",
				        "stylers": [
				            {
				                "lightness": 100
				            },
				            {
				                "visibility": "simplified"
				            }
				        ]
				    },
				    {
				        "featureType": "road",
				        "elementType": "geometry.fill",
				        "stylers": [
				            {
				                "color": "#d9e1e2"
				            }
				        ]
				    },
				    {
				        "featureType": "road",
				        "elementType": "labels",
				        "stylers": [
				            {
				                "visibility": "off"
				            }
				        ]
				    },
				    {
				        "featureType": "road.highway",
				        "elementType": "all",
				        "stylers": [
				            {
				                "color": "#6d6d7e"
				            },
				            {
				                "gamma": "1.70"
				            }
				        ]
				    },
				    {
				        "featureType": "road.arterial",
				        "elementType": "geometry.fill",
				        "stylers": [
				            {
				                "color": "#6d6d7e"
				            },
				            {
				                "gamma": "1.70"
				            }
				        ]
				    },
				    {
				        "featureType": "transit.line",
				        "elementType": "geometry",
				        "stylers": [
				            {
				                "visibility": "on"
				            },
				            {
				                "lightness": "100"
				            },
				            {
				                "color": "#6d6d7e"
				            },
				            {
				                "gamma": "1.84"
				            },
				            {
				                "saturation": "0"
				            }
				        ]
				    },
				    {
				        "featureType": "water",
				        "elementType": "all",
				        "stylers": [
				            {
				                "color": "#7dcdcd"
				            }
				        ]
				    }
				]
			},
		  mapIcon: ''
		}
	},

	mounted() {
		let self = this
		this.addMarker(self.lat, self.lng)
		console.log(self.lng)
	},

	methods: {
		addMarker(lat, lng) {
			console.log(lat)
		    const marker = {
		      lat: parseFloat(lat),
		      lng: parseFloat(lng)
		    }
		    this.markers.push({ position: marker });
		    this.center = marker;
		}
	}
};
</script>
